export const sellingPrice = (product) => Number(product?.price) || 0;

export const listedRetailPrice = (product) =>
  Number(product?.retailPrice || product?.oldPrice || 0);

export const hasDiscount = (product) => {
  const sale = sellingPrice(product);
  const retail = listedRetailPrice(product);
  return retail > sale && sale > 0;
};

export const discountPercent = (product) => {
  if (!hasDiscount(product)) return 0;
  return Math.round(100 - (sellingPrice(product) / listedRetailPrice(product)) * 100);
};
